import React, { FunctionComponent } from 'react'
import { QuestionnaireForm } from './QuestionnaireForm'
import { CodeValue } from '../../../model/Code'
import { QuestionnaireTemplate, QuestionnaireUpdateForm } from '../../../model/Questionnaire'

interface QuestionnaireHeaderProps {
  questionnaire: QuestionnaireTemplate
  saving: boolean
  scoreCodes: ReadonlyArray<CodeValue>
  handleUpdateQuestionnaire: (id: number, questionnaireUpdate: QuestionnaireUpdateForm) => void
}

export const QuestionnaireHeader: FunctionComponent<QuestionnaireHeaderProps> = ({
  questionnaire,
  scoreCodes,
  handleUpdateQuestionnaire,
}) => {
  return (
    <QuestionnaireForm
      questionnaireTemplate={questionnaire}
      scoreCodes={scoreCodes}
      onUpdate={handleUpdateQuestionnaire}
    />
  )
}
